/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useState } from 'react';
import { Camera, Trash } from 'phosphor-react';
import html2canvas from 'html2canvas';

import { Loading } from '../Loading';

export const ScreenshotButton = ({
  screenshot,
  onScreenShotTook,
}) => {
  const [isTakingScreenshot, setIsTakingScreenshot] = useState(false);

  async function handleTakeScreenShot() {
    setIsTakingScreenshot(true);

    const canvas = await html2canvas(document.querySelector('html'));
    const base64image = canvas.toDataURL('image/png');

    onScreenShotTook(base64image);
    setIsTakingScreenshot(false);
  }

  if (screenshot) {
    return (
      <button
        type="button"
        className="p-1 w-10 h-10 rounded-md border-transparent flex justify-end items-end text-zinc-400 hover:text-zinc-100 focus:ring-2 focus:ring-offset-2 focus:ring-offset-zinc-900 focus:ring-brand-500 transition-colors focus:outline-none"
        onClick={() => onScreenShotTook(null)}
        style={{
          minWidth: '38px',
          cursor: 'pointer',
          padding: '8px',
          borderRadius: '4px',
          border: 'none',
        }}
      >
        <Trash  style={{
          height: '25px'
        }}/>
      </button>
    );
  }

  return (
    <button
      type="button"
      style={{
        minWidth: '38px',
        padding: '8px',
        borderRadius: '4px',
        border: 'none',
        cursor: 'pointer',
      }}
      
      onClick={handleTakeScreenShot}
    >
      {isTakingScreenshot ? (
        <Loading /> 
      ) : (
        <Camera  />
      )}
    </button>
  );
};
